export var dataTestAttributes = {
  GOT_COUPON_BUTTON: 'GOT_COUPON_BUTTON',
  ADD_COUPON_BUTTON: 'ADD_COUPON_BUTTON',
  REMOVE_COUPON_BUTTON: 'REMOVE_COUPON_BUTTON',
  COUPON_CODE_INPUT: 'COUPON_CODE_INPUT',
  CHECKMARK_ICON: 'CHECKMARK_ICON',
  SR_COUPON_MESSAGE: 'SR_COUPON_MESSAGE',
  COUPON_TERMS_CTA: 'COUPON_TERMS_CTA',
  COUPON_TERMS_MODAL: 'COUPON_TERMS_MODAL',
  COUPON_TERMS_URL: 'COUPON_TERMS_URL'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/Coupon/dataTestAttributes.js
// module id = 3505
// module chunks = 11